import { defineStore } from "pinia";
import { createFrequencyState, frequencyGetters, } from "./plans.state";
import { frequencyServiceActions } from "./plans.actions.services";
import { frequencyPlanActions } from "./plans.actions.plans";
import { frequencyAnalysisActions } from "./analysis.actions";
export { createMethodPlan, syncServiceBitis } from "./planBuilders";
export { getSelectedBeta, resolveMethodKey, getOptimizationData, getAnalysisData, } from "./analysis.bridge";
/**
 * Frekans optimizasyonu plan state (Pinia).
 * Vuex kaynak: store/modules/planStore.js — namespace `plans` (store/index.js).
 * micro-5S-10: modüller `stores/frequency/` altında; davranış birebir.
 *
 * @typedef {'service' | 'vehicle'} PlanType
 *
 * Vuex `plans` state anahtarları (planStore.js satır 9–96):
 * - basePlans — methodKey → { gidis: Service[], donus: Service[] }
 * - activePlans — methodKey → { gidis: Service[], donus: Service[] }
 * - vehiclePlans — methodKey → VehiclePlan[]
 * - userModifications — methodKey → {
 *     parkurSureleri: Record<string, number>,
 *     addedServices: object[],
 *     removedServices: object[],
 *     modifiedServices: object[]
 *   }
 * - currentPlanType — PlanType (varsayılan: 'service')
 * - needsRefresh — boolean
 *
 * methodKey değerleri: method1, method2, method3, method4_10, method4_20, method4_30, method5, method6
 */
export const useFrequencyStore = defineStore("frequency", {
    state: () => createFrequencyState(),
    getters: frequencyGetters,
    actions: {
        ...frequencyServiceActions,
        ...frequencyPlanActions,
        ...frequencyAnalysisActions,
    },
});
